import script from "./ShapeItemThumbnail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShapeItemThumbnail.vue?vue&type=script&lang=ts&setup=true"

import "./ShapeItemThumbnail.vue?vue&type=style&index=0&id=09653543&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09653543"]])

export default __exports__